export const ClinicalNoteCard = {
  flow: 'y',
  gap: 'Y',
  padding: 'A',
  round: 'Y',
  background: (el, s) => (s.index !== undefined && s.index % 2 === 1) ? 'inkMid' : 'ink',

  state: {
    aiMode: false
  },

  TopRow: {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    justifyContent: 'space-between',

    LeftInfo: {
      flow: 'x',
      gap: 'Z',
      align: 'center flex-start',
      NoteDate: { text: (el, s) => s.date || '', fontSize: 'Y', color: 'inkMuted', fontWeight: '500' },
      Provider: { text: (el, s) => s.provider || '', fontSize: 'Y', color: 'inkMuted' }
    },

    AiToggle: {
      tag: 'button',
      text: 'AI',
      fontSize: 'X',
      fontWeight: '800',
      padding: 'X Y',
      round: 'X',
      border: 'none',
      cursor: 'pointer',
      background: (el, s) => s.aiMode ? 'violet' : 'violet.15',
      color: (el, s) => s.aiMode ? 'white' : 'violet',
      transition: 'background 0.15s, color 0.15s',
      ':hover': { opacity: '0.85' },
      onClick: (el, s) => s.update({ aiMode: !s.aiMode })
    }
  },

  SpecialtyBadge: {
    tag: 'span',
    show: (el, s) => !!s.specialty,
    text: (el, s) => s.specialty || '',
    fontSize: 'X',
    fontWeight: '700',
    padding: 'X Y',
    round: 'C',
    textTransform: 'capitalize',
    alignSelf: 'flex-start',
    background: (el, s) => {
      var sp = s.specialty
      if (sp === 'orthodontics') return 'purple.15'
      if (sp === 'endodontics') return 'red.15'
      if (sp === 'periodontics') return 'green.15'
      if (sp === 'surgery') return 'amber.15'
      if (sp === 'general') return 'blue.15'
      if (sp === 'prosthetics') return 'pink.15'
      return 'inkSurface'
    },
    color: (el, s) => {
      var sp = s.specialty
      if (sp === 'orthodontics') return 'purple'
      if (sp === 'endodontics') return 'red'
      if (sp === 'periodontics') return 'green'
      if (sp === 'surgery') return 'amber'
      if (sp === 'general') return 'blue'
      if (sp === 'prosthetics') return 'pink'
      return 'inkMuted'
    }
  },

  ProcedureTag: {
    tag: 'span',
    text: (el, s) => {
      if (s.aiMode && s.procedure) {
        var result = el.call('normalizeTerms', s.procedure)
        return result ? result.normalized : s.procedure
      }
      return s.procedure || ''
    },
    fontSize: 'Y',
    fontWeight: '600',
    padding: 'X Y',
    round: 'Y',
    background: (el, s) => s.aiMode ? 'violet.15' : 'teal.15',
    color: (el, s) => s.aiMode ? 'violet' : 'teal',
    alignSelf: 'flex-start'
  },

  SoapSummary: {
    tag: 'div',
    fontSize: 'Z',
    color: 'inkText',
    lineHeight: '1.4',
    html: (el, s) => {
      var t = s.summary || ''
      if (!s.aiMode) {
        var plain = t.length > 120 ? t.slice(0, 120) + '...' : t
        return plain
      }
      var result = el.call('normalizeTerms', t)
      if (!result || !result.changes || !result.changes.length) {
        return t.length > 120 ? t.slice(0, 120) + '...' : t
      }
      var output = result.normalized
      var changes = result.changes.slice().sort(function (a, b) { return b.position - a.position })
      for (var i = 0; i < changes.length; i++) {
        var c = changes[i]
        var before = output.slice(0, c.position)
        var term = output.slice(c.position, c.position + c.normalized.length)
        var after = output.slice(c.position + c.normalized.length)
        output = before +
          '<span style="background:rgba(139,92,246,0.15);padding:1px 3px;border-radius:3px;cursor:help" title="' + c.original + '">' +
          term + '</span>' + after
      }
      return output
    }
  },

  ExpandLink: {
    tag: 'span',
    text: '{{ expand | polyglot }}',
    fontSize: 'Y',
    color: 'teal',
    fontWeight: '600',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    ':hover': { textDecoration: 'underline' }
  }
}
